import Vuex from 'vuex'

// const Vue = window.Vue
import Vue from 'vue'
Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    userName: '',
    roleName: '',
    roleid: '',
    email: '',
    id: '',
    company_id: '',
    isProjectAdmin: false,
    isAdmin: false,
    config: {},
    CaseConfig: {},
    RunConfig: {},
    RunPageColumns: [],
    TodoConfigs: {},
    TestCasePageColumns: [],
    FilterCaseConfig: {},
    LoginToken:''
  },
  mutations: {
    SET_STATE_VALUES(state, payload) {
      state.userName = payload.userName;
      state.roleName = payload.roleName;
      state.roleid = payload.roleid;
      state.email = payload.email;
      state.id = payload.id;
      state.company_id = payload.company_id || '';
      state.isProjectAdmin = payload.isProjectAdmin;
      state.isAdmin = payload.isAdmin;
      state.config = payload.config;
      state.CaseConfig = payload.CaseConfig;
      state.RunConfig = payload.RunConfig;
      state.RunPageColumns = payload.RunPageColumns;
      state.TodoConfigs = payload.TodoConfigs;
      state.TestCasePageColumns = payload.TestCasePageColumns;
      state.FilterCaseConfig = payload.FilterCaseConfig;
      state.LoginToken = payload.LoginToken;
      // 将数据保存到 localStorage
      localStorage.setItem('myData', JSON.stringify(state));
    },
    SET_INITIAL_STATE(state, savedState) {
        Object.assign(state, savedState);
    }
  },
})

// 在应用程序初始化时，尝试从 localStorage 中加载之前保存的数据
const savedState = JSON.parse(localStorage.getItem('myData'));
if (savedState) {
  store.commit('SET_INITIAL_STATE', savedState);
}

export default store
